import { Component } from "@angular/core";

@Component({
    selector: 'requests-without-activities-report',
    templateUrl: './requests-without-activities-report.component.html',
    styleUrls: [
        '../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class RequestsWithoutActivitiesReportComponent {

    public reportFileNamePrefix: string = 'Заявки_Без_Активностей';

}